import React, { useEffect, useState } from "react";
import axios from "axios";

const PaymentSuccess = () => {
  const [state, setState] = useState({
    loading: true,
    ok: false,
    data: null,
    message: ""
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const session_id = params.get("session_id");
    const ref = params.get("ref");

    const API_BASE = process.env.REACT_APP_API_URL || "https://api.cheapcabgrab.com";

    async function verifyTokenFlow(token) {
      try {
        const res = await axios.get(`${API_BASE}/api/payment/verify`, {
          params: { token },
          withCredentials: true,
        });

        if (res.data?.ok && res.data?.booking) {
          setState({ loading: false, ok: true, data: res.data.booking });
        } else {


setState({
  loading: false,
  ok: false,
  message:
    res.data?.error === "Invalid or expired link"
      ? "⚠️ This confirmation link has expired or is no longer valid. " +
        "For security, CheapCabGrab payment confirmation links automatically expire after a short time. " +
        "If you need assistance, please contact support@cheapcabgrab.com."
      : res.data?.error ||
        "⚠️ We couldn’t confirm this payment. Please contact support@cheapcabgrab.com.",
});




        }
      } catch (err) {
        setState({
          loading: false,
          ok: false,
          message:
            err.response?.data?.error ||
            "Verification failed. Please contact support.",
        });
      }
    }

    async function confirmSessionFlow() {
      try {
        const res = await axios.get(`${API_BASE}/api/payments/confirm`, {
          params: { session_id, ref },
          withCredentials: true,
        });

        // ✅ If backend now includes token (new flow)
        if (res.data?.ok && res.data?.token) {
          // redirect to token URL for expiry enforcement
          window.location.href = `/payment-success?token=${res.data.token}`;
          return;
        }

        // ✅ Legacy fallback (no token field returned)
        if (res.data?.ok && res.data?.booking) {
          setState({ loading: false, ok: true, data: res.data.booking });
        } else {
          setState({
            loading: false,
            ok: false,
            message: res.data?.message || "We couldn't confirm the payment yet.",
          });
        }
      } catch (err) {
        setState({
          loading: false,
          ok: false,
          message:
            err.response?.data?.error ||
            "Confirmation failed. Please contact support.",
        });
      }
    }

    if (token) {
      // ✅ New secure flow
      verifyTokenFlow(token);
    } else if (session_id && ref) {
      // ✅ Legacy flow (used after Stripe redirect)
      confirmSessionFlow();
    } else {
      setState({ loading: false, ok: false, message: "Missing confirmation details." });
    }
  }, []);

  if (state.loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "4rem" }}>
        <p>⏳ Confirming payment…</p>
      </div>
    );
  }

  const b = state.data;

  return (
    <div
      style={{
        backgroundImage: "url('/bg-taxi.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "12px",
          padding: "2rem 3rem",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          maxWidth: "600px",
          textAlign: "center"
        }}
      >
        {state.ok ? (
          <>
            <h2 style={{ color: "green", marginBottom: "1rem" }}>✅ Payment Received</h2>
            <p style={{ fontSize: "1.1rem", marginBottom: "1rem" }}>
              Thanks for booking with <strong>CheapCabGrab</strong>. Your payment has been confirmed.
            </p>

            <div
              style={{
                textAlign: "left",
                fontSize: "0.95rem",
                margin: "1rem 0",
                lineHeight: "1.6"
              }}
            >
              <p><strong>Reference:</strong> {b.ref_code}</p>
              <p><strong>Pickup:</strong> {b.pickup_location}</p>
              <p><strong>Drop-off:</strong> {b.dropoff_location}</p>
              <p><strong>Date/Time:</strong> {new Date(b.pickup_datetime).toString()}</p>
              <p><strong>Vehicle:</strong> {b.vehicle_type?.toUpperCase()}</p>
              <p><strong>Fare:</strong> £{Number(b.fare).toFixed(2)}</p>
            </div>

            <p style={{ marginTop: "1rem" }}>
              We’ll be in touch if we need anything else.<br/>Safe travels! 🚖
            </p>

            <button
              onClick={() => (window.location.href = "/")}
              style={{
                background: "#ffc107",
                color: "#000",
                padding: "0.8rem 1.5rem",
                border: "none",
                borderRadius: "6px",
                marginTop: "1.5rem",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              ⬅ Back Home
            </button>
          </>
        ) : (
          <>
            <h2 style={{ color: "#d9534f" }}>⚠️ Payment Status</h2>
            <p>{state.message}</p>
            <button
              onClick={() => (window.location.href = "/")}
              style={{
                background: "#007bff",
                color: "#fff",
                padding: "0.8rem 1.5rem",
                border: "none",
                borderRadius: "6px",
                marginTop: "1rem",
                cursor: "pointer"
              }}
            >
              Back Home
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;

